import React, { useEffect, useState } from "react";
import { RenderPriceCell } from "../../globals/TableFunctions";
import {
  GridColDef,
  GridCellParams,
  GridRowParams,
  GridEvents,
  MuiEvent,
  GridCallbackDetails,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import PlayerDataGrid from "../DataGrid/PlayerDataGrid";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../hooks";
import { Player } from "../../types/types";
import { AddPlayer } from "../../state/reducers/ChosenPlayersReducer";
import { Paper } from "@mui/material";
import { CURRENT_SEASON } from "../../globals/BBLData";
const columns: GridColDef[] = [
  { field: "name", headerName: "Name", width: 180 },
  // { field: 'rank', headerName: 'Rank' , type: "number"},
  {
    field: "price",
    headerName: "Price",
    type: "number",
    width: 180,
    renderCell: (params: GridRenderCellParams<Date>) =>
      RenderPriceCell(params.row.price, params.row.price_change),
    sortComparator: (v1, v2) => {
      return 1;
    },
  },
  { field: "batSR", headerName: "BAT StrikeRate", type: "number", width: 150 },
  { field: "bwlSR", headerName: "BWL StrikeRate", type: "number", width: 150 },
  { field: "avgpts", headerName: "AVG Pts", type: "number" },
  { field: "be", headerName: "BE", type: "number" },
  { field: "dotballs", headerName: "Dot Balls", type: "number" },
  { field: "wickets", headerName: "AVG Wickets", type: "number" },
];

export default function SinglePositionTable({ players, positionname }) {
  let router = useNavigate();
  const dispatch = useAppDispatch();
  const [rows, setRows] = useState([]);
  console.log("SingleTeamTable: ", players);
  function PopulateRows() {
    let newRows = [];
    players.map(function (player) {
      let rank = -1;
      let price = -1;
      let price_change = -1;
      let stats = player.stats[0];
      let lastgame = player.stats[0]?.lastgame;
      let avgpts = -1;
      let be = -1;
      let dotballs = -1;
      let wickets = -1;
      let totalpoints = -1;
      let thestat = null;
      player.stats.map(function (stat) {
        if (stat.season === CURRENT_SEASON) {
          thestat = stat;
        }
      });
      if (thestat) {
        lastgame = thestat.lastgame;
      }
      if (lastgame) {
        be = lastgame.scbe;
        if (lastgame.positionrank) {
          lastgame.positionrank.map(function (posrank) {
            if (
              posrank.position.name === positionname ||
              posrank.positionname === "any"
            ) {
              rank = posrank.totalrank;
            }
          });
        }
        price = lastgame.price;
        price_change = lastgame.price_change;
      }
      if (!thestat && stats) {
        avgpts = stats.lastSeasonAVGPoints;
        dotballs = stats.lastSeasonAVGDots;
        wickets = stats.lastSeasonAVGWickets;
        totalpoints = stats.lastSeasonTotalPoints;
        if (positionname === "any") {
          rank = stats.overallPointsRank;
        }
      } else {
        avgpts = thestat.lastSeasonAVGPoints;
        dotballs = thestat.lastSeasonAVGDots;
        wickets = thestat.lastSeasonAVGWickets;
        totalpoints = thestat.lastSeasonTotalPoints;
        if (positionname === "any") {
          rank = thestat.overallPointsRank;
        }
      }

      if (lastgame) {
        newRows.push({
          id: player.id,
          name: `${player.firstname} ${player.lastname}`,
          rank: rank,
          price: price,
          price_change: price_change,
          batSR: player.batStrikeStat.avgSR,
          bwlSR: player.bwlStrikeStat.avgSR,
          avgpts: avgpts,
          be: be,
          dotballs: dotballs,
          wickets: wickets,
          totalpoints: totalpoints,
        });
      }
    });
    setRows(newRows);
  }

  const onCellClick = (
    params: GridCellParams,
    event: MuiEvent<React.MouseEvent>,
    details: GridCallbackDetails
  ) => {
    if (params.field !== "addbutton") {
      router("/player/" + params.row.id);
    } else {
      let player: Player = {
        id: "",
        firstname: "",
        lastname: "",
        pic: "",
        position: { name: "" },
        positions: [],
        stats: [
          { last5Games: [], timestamp: "", avgpts: 0, avgbase: 0, ppm: 0 },
        ],
        positionrank: [],
        ownerships: [],
      };
      players.map(function (p) {
        if (p.id === params.row.id) {
          player = p;
        }
      });
      dispatch(AddPlayer(player));
    }
  };

  useEffect(() => {
    PopulateRows();
  }, [players, positionname]);

  return (
    <Paper elevation={5} style={{ positon: "relative", paddingTop: "4rem" }}>
      <PlayerDataGrid
        height={"500px"}
        rows={rows}
        columns={columns}
        onCellClick={onCellClick}
        initialSortObject={{
          sorting: {
            sortModel: [{ field: "rank", sort: "asc" }],
          },
        }}
      />
    </Paper>
  );
}
